module.exports = {"330204001":"百丈街道","330204002":"东胜街道","330204003":"明楼街道","330204004":"白鹤街道","330204005":"东柳街道","330204006":"东郊街道","330204007":"福明街道","330204008":"新明街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330204.json
// module id = 879
// module chunks = 0